// import { apiSlice } from '../api/apiSlice'
// import 

import { id } from "date-fns/locale";
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const LOTS_BASE = "/lots";
const buildUrl = (endpoint) => LOTS_BASE + endpoint;

const lotsApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        createLot: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/create`),
                method: 'POST',
                body,
            }),
            providesTags: () => [{ type: 'Lots' }],
        }),
        updateLot: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/${body.id}`),
                method: 'PUT',
                body,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Lots'}, {type: 'LotsSingle'}],
        }),
        deleteLot: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/${body.id}`),
                method: 'DELETE',
                body,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Lots'}, {type: 'LotsSingle'}],
        }),
       
    })
});

export const {
    useCreateLotMutation,
    useUpdateLotMutation,
    useDeleteLotMutation,
  } = lotsApiSlice;
